import { AxiosError } from "axios"
import { ErrorOption, get } from "react-hook-form"
import { getErrorMessageWithFallback } from "utils/api"

const FALLBACK_KEY = "validations.anErrorOccured"

export const getGroupMutationFeedback = (error: AxiosError) => {
  const status = error.response?.status
  const message = getErrorMessageWithFallback(error, FALLBACK_KEY)
  const isRaw = message !== FALLBACK_KEY
  const loc = get(error, "response.data.detail[0].loc")
  const isNameLoc = Array.isArray(loc) && loc.includes("name")
  const onNameField =
    isRaw &&
    (status === 400 || (status === 422 && (isNameLoc || !Array.isArray(loc))))

  const nameError = onNameField
    ? ({
        type: "server",
        message: {
          key: "group.backendError",
          values: { message },
        },
      } as unknown as ErrorOption)
    : undefined

  return { onNameField, message, isRaw, nameError }
}
